import { gql } from '@apollo/client';

export const GET_NOTIFICATIONS_INFO = gql`
  query MyQuery($pageNo: Int!, $pageSize: Int!) {
    getMyNotifications(pageNo: $pageNo, pageSize: $pageSize) {
      total
      data {
        body
        created
        entityModel
        hash
        isUrgent
        id
        isViewed
        notificationId
        title
        entityId
        first
        last
        slug
        email
      }
    }
    getProfile {
      loggedIn
      personId
      personInfo {
        alternateEmail
        birthdate
        blacklistStatusBitsType
        company
        created
        email
        unreadNotificationCount
        title
        termsAccepted
        tagline
        registeredDate
        pendingApplicationCount
        notes
        moderatorFlag
        lastName
        modified
        displayName
        first
        firstName
        hasChildren
        gender
        headshot
        id
        incompleteActivityCount
        incompleteInvitationCount
        incompletePartyCount
        isAgeVerified
        isDeleted
        isExcludedFromExports
        isRegistrationInitiated
        isRegistryCompliant
        last
      }
      totalNotificationCount
      phoneNumber
      eventParticipationBitsMap
      countryCode
      addressInfo {
        addressAccuracy
        addressLat
        addressLong
        checksum
        city
        cityAccuracy
        cityLat
        cityLong
        countryId
        countryName
        created
        dma
        id
        isBlacklisted
        isGeocoded
        isValid
        modified
        postalAdditional
        postalCode
        stateOrProvince
        street1
        street2
        timezone
      }
    }
  }
`;

export const GET_NOTIFICATIONS_DETAILS = gql`
  query MyQuery($modelId: Int!, $modelName: String!) {
    getEventFeedById(modelId: $modelId, modelName: $modelName) {
      assetInfo {
        basename
        caption
        created
        hlsPlaylistUrl
        id
        mimeType
        mp4Url
        thumbnailUrl
        type
        url
        webmUrl
      }
      commentInfo {
        body
        id
        isPrioritised
      }
      feedInfo {
        commentCount
        created
        eventId
        likeCount
        liked
        reported
      }
      feedType
      id
      isFeatured
      personInfo {
        displayName
        headshot
        id
      }
      reviewInfo {
        body
        id
        rating
        title
        reviewFeedProductInfo {
          assetUrl
          id
          name
        }
        assetInfo {
          basename
          created
          hlsPlaylistUrl
          caption
          id
          mp4Url
          mimeType
          thumbnailUrl
          type
          url
          webmUrl
        }
      }
      sponsor {
        created
        description
        id
        isAdultonly
        isDeleted
        likeCount
        isFeatured
        liked
        name
        slug
        sponsorId
        sponsorName
        summary
        heroPlayList {
          autoPlay
          expires
          id
          mediaUrl
          mobileHero
          published
          assets {
            assetId
            basename
            description
            hlsPlaylistUrl
            mimeType
            mp4Url
            thumbnailUrl
            type
            url
            webmUrl
          }
        }
      }
    }
  }
`;
